export default "__VITE_PUBLIC_ASSET__cd8b8ac0__"